import { render } from "./NavigationHead.vue?vue&type=template&id=2637e691"
import script from "./NavigationHead.vue?vue&type=script&lang=js"
export * from "./NavigationHead.vue?vue&type=script&lang=js"

import "./NavigationHead.vue?vue&type=style&index=0&id=2637e691&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__